import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
} from "./principle3SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;
const COL_END = COL_I;

export const SHEET_NAME = "Stakeholder group";

const SHEET_TITLE =
  "List stakeholder groups identified as key for your entity and the frequency of engagement with each stakeholder group.";

const STAKEHOLDER_GROUPS = [
  ["Investors", "investors"],
  ["Shareholders", "shareholders"],
  ["Customers", "customers"],
  ["Business Partners", "businessPartners"],
  ["Employees & Workers", "employeesAndWorkers"],
  ["Regulatory Bodies", "regulatoryBodies"],
  ["Trade bodies & other organizations", "tradeBodies"],
  ["Local community", "localCommunity"],
];

function channelText(item) {
  if (item?.channelOfCommunication === "Others") {
    return `Others: ${safeText(item?.newChannelOfCommunication)}`;
  }
  return safeText(item?.channelOfCommunication);
}

function frequencyText(item) {
  if (item?.frequency === "Others") {
    return `Others: ${safeText(item?.newFrequency)}`;
  }
  return safeText(item?.frequency);
}

function setColumnWidths(ws) {
  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 22;
  ws.getColumn("F").width = 18;
  ws.getColumn("G").width = 22;
  ws.getColumn("H").width = 18;
  ws.getColumn("I").width = 36;
}

export function buildStakeholderGroupSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setColumnWidths(ws);
  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_4, { mergeEnd: COL_END });

  const stakeholders = sectionC?.principle4?.essentialIndicators?.identificationOfStakeholders || {};

  mergeRow(ws, TITLE_ROW, COL_D, COL_END, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Stakeholder Group", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(
    ws,
    HEADER_ROW,
    COL_F,
    "Whether Identified as Vulnerable & Marginalized Group",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );
  setCell(ws, HEADER_ROW, COL_G, "Channels of communication", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, "Frequency of engagement", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(
    ws,
    HEADER_ROW,
    COL_I,
    "Purpose and scope of engagement including topics and concerns raised during such engagement",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );

  const rows = STAKEHOLDER_GROUPS.filter(([, key]) => {
    const row = stakeholders?.[key];
    if (!row || typeof row !== "object") return false;
    return Object.values(row).some((value) => value !== null && value !== undefined && String(value).trim() !== "");
  });

  const dataRows = rows.length ? rows : STAKEHOLDER_GROUPS;

  dataRows.forEach(([label, key], idx) => {
    const row = DATA_START_ROW + idx;
    const item = stakeholders?.[key] || {};

    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, label, { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.wheatherIdentified), { align: "center" });
    setCell(ws, row, COL_G, channelText(item), { align: "center" });
    setCell(ws, row, COL_H, frequencyText(item), { align: "center" });
    setCell(ws, row, COL_I, safeText(item?.purpose), { align: "left", vertical: "top" });
    ws.getRow(row).height = Math.max(18, Math.ceil(safeText(item?.purpose).length / 50) * 15);
  });

  return ws;
}
